import { useLayoutEffect, type RefObject } from "react";
import { useLocation } from "react-router";

/**
 * Resets a scroll container to the top on every route change. The app shells
 * keep a single persistent scrollable `<main>` across navigations, so without
 * this the next screen inherits the previous one's scroll position and opens
 * mid-page (the header/titles scrolled off). Runs in a layout effect so the
 * reset happens before paint (no flash of the new screen mid-scroll), and uses
 * scrollTop/scrollLeft (not scrollTo) so it works in both the browser and jsdom.
 */
export const useScrollResetOnNavigate = (
  ref: RefObject<HTMLElement | null>,
): void => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    const el = ref.current;
    if (el) {
      el.scrollTop = 0;
      el.scrollLeft = 0;
    }
  }, [pathname, ref]);
};
